<template>
  <el-table
    :data="newList"
    height="300px">
    <el-table-column
      prop="idx"
      width="50">
    </el-table-column>
    <el-table-column
      prop="productName"
      label="商品名称">
    </el-table-column>
    <el-table-column
      width="80"
      prop="averageProductAmount"
      :formatter="row=> row.averageProductAmount + '元'"
      label="平均货单价">
    </el-table-column>
    <el-table-column
      width="80"
      prop="totalAmount"
      :formatter="row=> row.totalAmount + '元'"
      label="销售金额">
    </el-table-column>
    <el-table-column
      width="80"
      prop="totalProductSoldQuantity"
      :formatter="row=> row.totalProductSoldQuantity + '件'"
      label="商品数">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ProductTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    newList() {
      return this.list.map((i, idx) => {
        return {
          ...i,
          idx: idx + 21
        }
      })
    }
  }
}
</script>

